import { Component, Input } from '@angular/core';
import { TableColumnComponent } from '../table-column/table-column.component';
import { get } from 'lodash-es';

@Component({
    selector: 'app-column-company',
    templateUrl: './column-company.component.html',
    styleUrls: ['./column-company.component.scss'],
    standalone: false,
})
export class ColumnCompanyComponent extends TableColumnComponent {
    @Input() public columnKeyName = 'company';
    @Input() public isCompanyFromTickets = false;

    public getEntityPropertyForCompanyOnTickets(entity: any): string {
        return get(entity.company_data, this.entityProperty);
    }
}
